import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { api, API } from "../lib/api";

/**
 * Admin-uploaded promotional poster — shown as a big banner right below the
 * fixed header on Landing / Success / Member pages. Dismissible per session.
 */
export default function PromoBanner() {
    const [banner, setBanner] = useState(null);
    const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("sc_banner_dismissed") === "1");

    useEffect(() => {
        api.get("/public/banner").then((r) => setBanner(r.data)).catch(() => setBanner({ enabled: false }));
    }, []);

    const dismiss = () => {
        setDismissed(true);
        sessionStorage.setItem("sc_banner_dismissed", "1");
    };

    if (!banner?.enabled || dismissed) return null;

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className="relative w-full mt-16 bg-black border-b border-gold/30 overflow-hidden"
                data-testid="promo-banner"
            >
                <button
                    onClick={dismiss}
                    aria-label="Close"
                    data-testid="promo-banner-close"
                    className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-black/60 border border-gold/30 text-ink-primary hover:text-gold hover:border-gold flex items-center justify-center transition-colors"
                >
                    <X size={15} />
                </button>
                <img
                    src={`${API}/public/banner/image?v=${encodeURIComponent(banner.updated_at || "")}`}
                    alt="ScottsClub"
                    className="w-full max-h-[62vh] object-contain mx-auto"
                    data-testid="promo-banner-image"
                />
            </motion.div>
        </AnimatePresence>
    );
}
